module.exports = __webpack_public_path__ + "kz.svg?6108408d532ee6f789944ef92e395f4f";